import { render, staticRenderFns } from "./plateField.vue?vue&type=template&id=57c72a9a&"
import script from "./plateField.vue?vue&type=script&lang=js&"
export * from "./plateField.vue?vue&type=script&lang=js&"
import style0 from "./plateField.vue?vue&type=style&index=0&id=57c72a9a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports